import React, { useState } from 'react'
import useFindTokens from '@plug-core/hooks/useFindTokens'
import { IoSync } from 'react-icons/io5'
import { useCurrentWallet, useDevMode } from '@plug-core/state'
import { CircularProgress, Stack } from '@mui/material'
import Button from '@components/Button'
import { HiAdjustments } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import { useTranslation } from 'react-i18next'

export const TokenListButtons = () => {
  const { devEnabled } = useDevMode()
  const { findTokens } = useFindTokens()
  const { currentWallet } = useCurrentWallet()
  const { t } = useTranslation()

  const navigate = useNavigate()

  const [isFindingTokenBalances, setIsFindingTokenBalances] = useState(false)

  return (
    <Stack width={120} mx="auto" px={1} mt={0.5} mb={1.5}>
      {!devEnabled && (
        <Button
          startIcon={<HiAdjustments />}
          onClick={() => navigate(`${ROUTES.MANAGE_TOKENS}`)}
          size="small"
          fullWidth
        >
          {t('home.tokenListButtons.manage')}
        </Button>
      )}

      <Button
        startIcon={
          isFindingTokenBalances ? (
            <CircularProgress size={20} thickness={5} />
          ) : (
            <IoSync size={20} />
          )
        }
        onClick={async () => {
          setIsFindingTokenBalances(true)
          await findTokens(currentWallet)
          setIsFindingTokenBalances(false)
        }}
        size="small"
        fullWidth
        loading={isFindingTokenBalances}
      >
        {t('home.tokenListButtons.findTokens')}
      </Button>
    </Stack>
  )
}
